import React from 'react';
import {removeHtmlStyles} from "../utils/stringUtils";

class ImportantInformationEntry extends React.Component {
    render () {
        if (!this.props.content) {
            return false;
        }

        return (
            <div>
                {this.props.title &&
                    <div className="text-primary-dark uppercase mt-2">
                        {this.props.title}
                    </div>
                }

                <div className="text leading-normal" dangerouslySetInnerHTML={{__html: removeHtmlStyles(this.props.content)}} />

            </div>
        );
    }
}

export default ImportantInformationEntry;